//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import common from '@/assets/js/Common'
import api from '@/assets/js/Api'

export default {
	name: 'goodsList',
	props: {
        goodsData: {
            default: function(data){
                return [];
            },
            type: Array,
        }
	},
	data() {
		return {

		}
	},

}



// WEBPACK FOOTER //
// ./src/components/goodsList.vue